<template>
  <card-modal :visible="true" :title="title" :showPreview="false" :okText="'Guardar'" :disableOk="true">
    <div id="modal-edit-content" class="content">
      <div class="columns" v-if="userLoggedAdmin">
        <div class="column is-12">
          <div class="swicth-container">
            <label class="label">Administrador</label>
            <vb-switch type="primary" :checked="userData && !!parseInt(userData.admin)"></vb-switch>
          </div>
        </div>
      </div>
      
      <div class="columns">
        <div class="column is-half">
          <label class="label">Nome de utilizador</label>
          <p class="control">
            <input class="input" type="text" placeholder="Nome" v-model="user.name">
          </p>
        </div>
        <div class="column is-half">
          <label class="label">Email</label>
          <p class="control">
            <input class="input" 
                   type="text" 
                   placeholder="Email" 
                   v-bind:disabled="disableEmail"
                   v-model="user.email">
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column is-half">
          <label class="label">Nova password</label>
          <p class="control">
            <input class="input password-input"
                   :class="{'is-danger':passwordMissmatch}" 
                   type="password" 
                   placeholder="Nova password" 
                   v-model="user.newPassword">
          </p>
        </div>
        <div class="column is-half">
          <label class="label">Repetir password</label>
          <p class="control">
            <input class="input password-input" 
                   :class="{'is-danger':passwordMissmatch}" 
                   type="password" 
                   placeholder="Repetir password" 
                   v-model="user.newPasswordRepeat">
          </p>
        </div>
      </div>
    </div>
  </card-modal>
</template>

<script>
import CardModal from '../Util/CardModal'
import VbSwitch from '../Util/Switch'

export default {
  components: {
    CardModal,
    VbSwitch
  },

  props: {
    title: String,
    userData: Object
  },

  data () {
    return {
      showPreview: false,
      passwordMissmatch: false,
      disableEmail: false,
      user: {
        id: null,
        admin: null,
        name: null,
        email: null,
        newPassword: '',
        newPasswordRepeat: ''
      },
      adminSwitch: null
    }
  },

  computed: {
    currentEvent () {
      return window.store.state.event.nextEvent
    },

    userLoggedAdmin () {
      return parseInt(window.store.state.user.admin)
    },

    submitIsActive () {
      if (this.user.id) {
        return Boolean(this.user.name && this.user.email)
      } else {
        return Boolean(this.user.name && this.user.email && this.user.newPassword && this.user.newPasswordRepeat)
      }
    }
  },

  methods: {
  },

  mounted () {
    this.adminSwitch = false

    if (typeof this.userData !== 'undefined') {
      this.user.name = this.userData.name
      this.user.email = this.userData.email
      this.user.id = parseInt(this.userData.id)
      this.user.admin = parseInt(this.userData.admin)

      this.adminSwitch = !!this.user.admin
      this.disableEmail = true
    }
  },

  watch: {
    currentEvent: function (val) {
      if (val === 'switch-change-true') {
        this.adminSwitch = true
      }
      if (val === 'switch-change-false') {
        this.adminSwitch = false
      }
      if (val === 'modal-card-close') {
        this.$destroy()
      }
      if (val === 'modal-card-ok') {
        if (this.user.newPassword !== this.user.newPasswordRepeat) {
          this.passwordMissmatch = true
        } else {
          this.passwordMissmatch = false
          if (this.user.id) {
            window.store.dispatch('updateUser', this.user)
          } else {
            window.store.dispatch('saveUser', this.user)
          }
          window.store.dispatch('newEvent', 'modal-card-close')
        }
      }
      if (val === 'modal-card-preview') {
        // no preview
      }
      if (val === 'modal-card-cancel') {
        window.store.dispatch('newEvent', 'modal-card-close')
      }
    },

    submitIsActive: function (val) {
      if (val) {
        document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled')
      } else {
        document.querySelector('.card-modal-ok-btn').classList.add('is-disabled')
      }
    },

    adminSwitch (val) {
      console.log('watch switch 1', val, this.user.admin, this.adminSwitch)
      this.user.admin = val ? 1 : 0
      console.log('watch switch 2', val, this.user.admin, this.adminSwitch)
    }
  }
}
</script>

<style>
  .modal-center-icon {
    width: 100% !important;
  }

  .swicth-container {
    display: flex;
  }

  .swicth-container .switch {
    margin-left: 5px;
  }
</style>


// WEBPACK FOOTER //
// UserEditModal.vue?236eb091